export default {
    loginTitle: "Welcome back",
    loginDescription: "Continue your language learning journey. Sign in to access your dashboard and tests.",
    callToRegisterActionLabel: "Don't have an account?",
    callToLoginActionLabel: "Already have an account?",
    registerActionLabel: "Get started",
    registerActionButtonLabel: "Create Account",
    loginActionLabel: "Sign in",
    callToResetPasswordActionLabel: "Forgot password?",
    registerFormTitle: "Create Your Account",
    registerFormDescription: "Start your journey to language mastery",
    previousRegistrationStepActionLabel: "Previous",
    nextRegistrationStepActionLabel: "Next",
    googleRegistrationActionLabel: "Register with Google",
    facebookRegistrationActionLabel: "Register with Facebook",
    googleLoginActionLabel: "Login with Google",
    facebookLoginActionLabel: "Login with Facebook",

    forgotPasswordTitle: "Forgot your password?",
    forgotPasswordDescription: "Enter the email address on your account and we'll send you a link to choose a new password.",
    sendResetLinkActionLabel: "Send reset link",
    backToLoginActionLabel: "Back to sign in",
    resetPasswordTitle: "Choose a new password",
    resetPasswordDescription: "Pick a password you haven't used before on this account.",
    resetPasswordActionLabel: "Reset password",
    resetPasswordEmailSentTitle: "Check your inbox",
    resetPasswordEmailSentDescription: "If {{email}} matches an account, a reset link is on its way. The link expires in 60 minutes.",
    resetPasswordSuccessTitle: "Password updated",
    resetPasswordSuccessDescription: "Your password has been changed and you've been signed out everywhere else.",
    passwordTooShortMessage: "Password must be at least {{count}} characters long.",

    verifyEmailLoadingMessage: "Verifying your email address...",
    verifyEmailSuccessTitle: "Email verified",
    verifyEmailSuccessDescription: "Thanks — your email address is confirmed and your account is fully active.",
    verifyEmailFailedTitle: "We couldn't verify this link",
    verifyEmailBannerTitle: "Verify your email address",
    verifyEmailBannerDescription: "We sent a confirmation link to {{email}}. Verify it to keep full access to your account.",
    resendVerificationEmailActionLabel: "Resend email",
}
